export const meta = {
  id: '41-past-narrative-and-letters',
  order: 41,
  checkFocus: { tense: ['pluperfect', 'past-habitual'] },   // what the end-of-lesson check tests first
  titleFi: 'Menneen ajan kertomus ja kirjeet',
  titleEn: 'Telling the past, and letters',
  // + Sanapaja's own words this lesson first needs (docs/COURSE.md "Own words in the lessons"; waves/wave-NN/lessons.json)
  lemmaIds: [
    'haerēbagon',
    'āmāzigon',
    'rūnagon',
    'mīvojughagon',
    'ozdakogon',
    'uglaesagon',
    'vumbagon',
    'hēnkirī',
    'vasīr',
    'hembār',
    'jaes',
    'vēttrir',
    'dohaertros',
    'dohaertiarzy',
    'rūnarys',
    'raqītsos',
    'jorrāeliarzy',
    'tolmio',
    'ōregon',
    'ȳgha',
    'rāelagon',
    'pyghagon',
    'ajomemēbagon',
    'mōris',
    'biarves',
    'biare',
    'rijes',
    'biarvose',
    'gīhor',
    'geros',
    'biarvī',
    'saelie',
    'tōmelie',
    'massa',
    'ours:sȳrennon', 'ours:mōrqittāves',
    'ours:korzinon',
    'ours:hūriapos',
    'ours:nīro-jēda',
    'ours:nūmiō-jēda',
    'ours:tego-jēda',
    'ours:perzo-jēda',
    'ours:grozo-jēda',
    'ours:jaedo-jēda',
    'ours:parmo-jēda',
    'ours:derēptrio-jēda',
    'ours:averō-jēda',
    'ours:masso-jēda',
    'ours:morgho-jēda',
    'ours:qēlo-jēda',
    'ours:lisensi',
  ],
  exampleIds: [
    'got-s4e03-004',
    'got-s5e04-012',
    'hotd-s3e08-002',
    'got-s3e04-012',
    'hotd-s2e04-002',
    'got-s7e02-003',
    'got-s5e04-011',
    'ex-1693d199fc47',
    'ex-a1d29450428a',
    'ex-8ed810d2f0a2',
    'ex-5af89bfd82cf',
    'ex-13537ed19fcd',
    'ex-bb25187388bd',
    'ex-c9b6b47ca314',
    'ex-4cfb0b7129c5',
    'ex-8b624009f31c',
    'ex-f3f40cf567d3',
    'ex-33b16c683c61',
    'ex-c53f25e7a310',
    'ex-dc8bd0596993',
    'ex-fa2a87cec2d2',
    'ex-6ba5d2eba7fc',
    'ex-45fe8b619c5e',
    'ex-5fab68e6d60d',
    'ex-ee655aa956a2',
    'ex-584ff507e062',
    'ex-7cd1b4b8215d',
    'ex-8137c0dc87dd',
  ],
  sources: [
    'https://wiki.languageinvention.com/index.php?title=User:Najahho/High_Valyrian_Verb_Conjugation',
    'https://artoflanguageinvention.com/papers/ling183_w3d4.pdf',
    'https://wiki.languageinvention.com/index.php?title=High_Valyrian_Grammar',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_Duolingo_Tips_and_Notes',
    'https://wiki.languageinvention.com/index.php?title=Dohaertros',
    'https://wiki.languageinvention.com/index.php?title=Dohaertiarzy',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_phrasebook/Greetings',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_phrasebook/Farewells',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_phrasebook/Love',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_phrasebook/Festivities',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_numerals',
    'https://wiki.languageinvention.com/index.php?title=User:Najahho/High_Valyrian_Pronouns',
    'https://wiki.languageinvention.com/index.php?title=Raqītsos',
    'https://wiki.languageinvention.com/index.php?title=Jorrāeliarzy',
    'https://wiki.languageinvention.com/index.php?title=Biarvī',
    'https://wiki.languageinvention.com/index.php?title=Geros',
    'https://wiki.languageinvention.com/index.php?title=Rytsuragon',
    'https://archiveofourown.org/works/24077005/chapters/172067518',
  ],
  // the week (docs/COURSE.md "Lesson hub")
  grammar: ['pluperfect'],
  drills: { tense: ['pluperfect', 'past-habitual', 'future-perfect'] },
  showLines: ['got-s4e03-004', 'got-s5e04-012', 'hotd-s3e08-002', 'got-s3e04-012', 'hotd-s2e04-002', 'got-s7e02-003', 'got-s5e04-011'],
  pronunciation: { focus: 'rhythm', lines: ['got-s4e03-004', 'got-s5e04-012', 'got-s3e04-012'] },
  phrases: ['biarvose', 'geros', 'biarvī'],
  letter: {
    fi: 'Kirjoita oikea kirje: puhuttelu, kuulumiset menneessä ajassa, toivotus ja lopetus.',
    en: 'Write a real letter: greeting, news in the past tense, a wish and a closing.',
    model: 'got-s3e07-letter',
  },
  scene: 'hotd-s2e04-1',
}

# Menneen ajan kertomus ja kirjeet

Ensin menneen ajan järjestelmä loppuun: mennyt toistuva ja pluskvamperfekti. Sitten niillä kirjoitetaan: miten valyriankielinen kirje rakentuu puhuttelusta lopetukseen.

## Olin ollut, minulla oli tapana: menneen ajan järjestelmä

Kirjeessä kerrotaan usein, mitä on tapahtunut: mitä teit eilen, mitä olit tehnyt sitä ennen ja mitä
teit ennen vanhaan. Duolingosta osaat jo kaksi menneen ajan muotoa: **perfektin** (teko on tehty,
<Hv glossed>iprattan</Hv> ’söin, olen syönyt’) ja **imperfektin** (teko oli käynnissä, <Hv glossed>ipradilen</Hv> ’olin
syömässä’). Tällä oppitunnilla järjestelmä täydentyy kahdella muodolla: **pluskvamperfektillä** ja
**menneellä toistuvalla**.

## Seitsemän aikamuotoa yhdessä taulukossa

Wikin verbintaivutussivu jäsentää aikamuodot kahdella akselilla: *milloin* (nyt, ennen, ajattomasti)
ja *miten* tekoa katsotaan (perusmuoto, keskeneräinen, päättynyt). Tässä verbin <Hv glossed>ipradagon</Hv>
’syödä’ yksikön 3. persoona:

<div className="lesson-table-wrap" tabIndex={0}>
<table className="lesson-table">
  <thead><tr><th></th><th>perusaspekti</th><th>keskeneräinen</th><th>päättynyt</th></tr></thead>
  <tbody>
    <tr><td><strong>nyt</strong></td><td>preesens <Hv glossed>ipradas</Hv></td><td>futuuri <Hv glossed>ipradilza</Hv></td><td>perfekti <Hv glossed>iprattas</Hv></td></tr>
    <tr><td><strong>ennen</strong></td><td>–</td><td>imperfekti <Hv glossed>ipradiles</Hv></td><td>pluskvamperfekti <Hv glossed>iprattes</Hv></td></tr>
    <tr><td><strong>ajaton</strong></td><td>aoristi <Hv glossed>ipradis</Hv></td><td>–</td><td>mennyt toistuva <Hv glossed>iprattis</Hv></td></tr>
  </tbody>
</table>
</div>

Taulukosta näkee kaksi asiaa. Futuuri ja imperfekti ovat sukua (molemmissa on *-il-*), ja
pluskvamperfekti ja mennyt toistuva rakentuvat perfektin vartalolle (<Hv>ipratt-</Hv>). Kun osaat
verbin perfektin, osaat siis jo puolet tämän oppitunnin muodoista.

<Note>
Taulukko on wikin taivutussivulta: sen mukaan aikamuodot ”näyttävät” noudattavan tätä kaavaa.
Myös Petersonin omat kurssikalvot jäsentävät aikamuodot kahdella akselilla, mutta ryhmittelevät ne
toisin: aoristi on niissä ”toistuva preesens” (*Habitual Present*). Muistisääntönä taulukko toimii
erinomaisesti.
</Note>

## Ensin kertaus: perfekti ja imperfekti kertomuksessa

Daenerys kertoo Meereenin orjille matkastaan. Tapahtumat seuraavat toisiaan, joten ne ovat perfektissä:

<Line id="got-s4e03-004" />

<Interlinear hv="Ēlī Astaprot ist|an." gloss="ensin Astapor-DAT mennä-PRF.1SG" fi="Ensin menin Astaporiin." />

<Example id="ex-1693d199fc47" />

Imperfekti taas antaa kertomukselle taustan: mikä oli käynnissä tai voimassa. Jälleen Daenerys:

<Line id="got-s5e04-012" />

<Hv l="sagon" glossed>Īlis</Hv> on verbin <Hv>sagon</Hv> imperfekti (vartalo <Hv>īl-</Hv>, <LessonLink n={43}>oppitunti 43</LessonLink>): ’isännät *olivat*
laki’ – tila, joka vallitsi.

Daemonin <Hv glossed>gīmīlē</Hv> on myös imperfekti: ’sinä tiesit (koko ajan)’.

<Line id="hotd-s3e08-002" />

## Mennyt toistuva: ”minulla oli tapana”

Wikin kielioppisivun mukaan mennyt toistuva kertoo asioista, jotka tapahtuivat yleisesti tai
toistuvasti jonkin menneen ajanjakson aikana. Englanniksi sen voi usein kääntää *used to*
-rakenteella. Taivutussivu huomauttaa lisäksi tärkeästä asiasta: **imperfektillä ei voi ilmaista
tapaa**. ”Söin ennen puuroa joka aamu” ei ole imperfekti vaan mennyt toistuva.

Muodostus: perfektivartalo + aoristin päätteet (*-in, -ia, -is, -iti, -iat, -isi*). Ajattele sitä
**menneisyyden aoristina**: aoristi kertoo, millaista on aina, mennyt toistuva taas, millaista oli
silloin.

<Paradigm lemma="ipradagon" filter="indicative.active.past-habitual" />

<Paradigm lemma="sagon" filter="indicative.active.past-habitual" />

Daenerys Astaporissa vapautetuille:

<Line id="got-s3e04-012" />

<Interlinear hv="Jevo glaesoti rȳ buzdari ist|iat." gloss="teidän-TERR.GEN.PL elämä-GEN.PL läpi orja-NOM.PL olla-PST.HAB.2PL" fi="Te olitte orjia koko elämänne." />

Orjuus ei ollut yksi teko vaan tila, joka jatkui vuosia. Perfekti <Hv l="sagon">istāt</Hv> sanoisi vain, että
tila on ohi.

Nuori Rhaenyra Daemonille:

<Line id="hotd-s2e04-002" />

<Interlinear hv="Ñuho laehoti, jaes ist|ia." gloss="minun-SOL.DAT.PL silmä-DAT.PL jumala-NOM olla-PST.HAB.2SG" fi="Minun silmissäni sinä olit (silloin) jumala." />

Ja Melisandre Daenerysille (repliikki on tuttu jo <LessonLink n={40}>oppitunnilta 40</LessonLink>):

<Line id="got-s7e02-003" />

<Hv glossed>Dohaeriros istin</Hv> ’olin orja’ – pitkä ajanjakso, joka on nyt ohi.

### Vertailu suomeen

<Note>
**Suomessa ei ole tätä aikamuotoa.** ”Olitte orjia koko elämänne” on suomeksi tavallinen mennyt aika (koulukieliopin imperfekti), ja
toistuvuus jää ajanmääreen (*koko elämänne*) varaan. Kun suomessa halutaan korostaa tapaa, käytetään
sanoja (*minulla oli tapana*, *ennen*, *aina*: *luin ennen paljon*) tai frekventatiivijohdosta
(*lueskelin*). Valyriassa tapa ilmaistaan verbin taivutuksella. Nyrkkisääntö kirjeisiin: jos
sanoisit suomeksi ”ennen” tai ”oli tapana”, valitse mennyt toistuva.
</Note>

### Entiset orjat ja entiset isännät

Hizdahr kuningattarelle:

<Line id="got-s5e04-011" />

<Note>
Hizdahrin *kesosy* on Petersonin tahaton virhe (wikin alaviite; Petersonin Conlang Dialogue -selitykset): kollektiivi *valar* saa verbin yksikköön, joten odotettu muoto on <Hv l="sagon">kesos</Hv>. Peterson jätti muodon ennalleen, koska se sopii puhujalle.
</Note>

Sanakirjassa <Hv glossed>dohaertros</Hv> on ’entinen orja’ ja <Hv glossed>dohaertiarzy</Hv> ’entinen isäntä’.
Verbin <Hv glossed>dohaeragon</Hv> ’palvella’ menneen toistuvan partisiipit ovat <Hv glossed>dohaertre</Hv> ’joka
palveli (ennen)’ ja <Hv glossed>dohaertiarza</Hv> ’jota palveltiin (ennen)’, ja substantiivit näyttävät
olevan johdettuja juuri niistä. (Tämä on oma päätelmämme muotojen perusteella; wiki ei sano sitä
suoraan.) Sama sana esiintyi jo yllä Daenerysin matkakertomuksessa muodossa *dohaertrossa*: ’ne,
jotka olivat orjia Astaporissa’.

## Pluskvamperfekti: ”olin tehnyt”

Pluskvamperfekti kertoo teosta, joka oli tapahtunut jo ennen jotakin toista mennyttä hetkeä:
englanniksi *had done*, suomeksi *olin tehnyt*. Tässä suomi ja valyria vastaavat merkitykseltään
täysin toisiaan, vain muoto on eri: suomi käyttää apuverbiä, valyria päätettä.

Muodostus: perfektivartalo + *e*-teemavokaali: *-en, -ē, -es, -in, -ēt, -is*. Huomaa, että
päätteet ovat samat kuin imperfektissä (<Hv>ipradilen</Hv>, <Hv>ipradilē</Hv>, <Hv>ipradiles</Hv> …).

<Paradigm lemma="ipradagon" filter="indicative.active.pluperfect" />

<Compare fi="olin syö|nyt" hv="ipratt|en" label="pluskvamperfekti" />

Kaksi erikoisuutta:

- Monikon 3. persoona on sama kuin perfektissä: <Hv>iprattis</Hv>.
- Pluskvamperfektillä **ei ole omaa subjunktiivia**: se on sama kuin perfektin subjunktiivi. Kielteinen
  ”en ollut syönyt” on siis muodoltaan sama kuin ”en ole syönyt”: <Hv glossed>ipratton daor</Hv>.

<Note>
**Suoraan sanottuna pluskvamperfektistä on vähän todisteita.** Taivutussivun mukaan siitä tunnetaan
vain kaksi muotoa, <Hv glossed>zālten</Hv> ’olin polttanut’ ja passiivi <Hv glossed>zālteks</Hv> ’minut oli poltettu’,
ja kaikki muut muodot ovat päätelmiä. Sarjojen repliikeistä emme löytäneet yhtään yksiselitteistä
pluskvamperfektiä. Taulukko on johdonmukainen ja käyttökelpoinen, mutta tämä on kurssin
epävarmimpia muotoja.
</Note>

Duolingosta tuttu <Hv glossed>sīr</Hv> ’jo’ sopii pluskvamperfektiin yhtä hyvin kuin perfektiin:
<Hv glossed>sīr ipratten</Hv> ’olin jo syönyt’. Samoin <Hv glossed>sīrgō</Hv> ’aiemmin’:

<Example id="ex-a1d29450428a" />

## Samannäköiset muodot

Koska kolme aikamuotoa käyttää samaa vartaloa, muodot ovat joskus täsmälleen samat. Silloin
asiayhteys ratkaisee.

<div className="lesson-table-wrap" tabIndex={0}>
<table className="lesson-table">
  <thead><tr><th>Muoto</th><th>Mahdolliset tulkinnat</th></tr></thead>
  <tbody>
    <tr><td><Hv>iprattis</Hv></td><td>perfekti mon. 3 · pluskvamperfekti mon. 3 · mennyt toistuva yks. 3</td></tr>
    <tr><td><Hv>iprattin</Hv></td><td>pluskvamperfekti mon. 1 · mennyt toistuva yks. 1</td></tr>
    <tr><td><Hv glossed>istin</Hv></td><td>lisäksi <Hv glossed>sagon</Hv> ja <Hv glossed>jagon</Hv> jakavat perfektivartalon <Hv>ist-</Hv></td></tr>
  </tbody>
</table>
</div>

Esimerkiksi Melisandren <Hv glossed>istin</Hv> voisi muodon puolesta olla myös ’olimme olleet’ tai
’olimme menneet’ – mutta lauseen subjekti on yksi orja.

<Note>
**Wikin sivut eroavat tässä:** taivutussivulla menneen toistuvan monikon 1. persoona on merkitty
kysymysmerkillä (<Hv fi="meillä oli tapana haluta">jēldi</Hv> ja muissa verbeissä *-i?*), mutta wikin taivutustaulukoissa pääte
on *-iti* (<Hv>iprattiti</Hv>). Sovelluksen taulukossa on jälkimmäinen.
</Note>

## Passiivi lyhyesti

Molemmilla aikamuodoilla on passiivi, ja se muodostetaan samalla *-ks*-periaatteella kuin muissakin:
pluskvamperfekti <Hv glossed>zālteks</Hv> ’minut oli poltettu’, mennyt toistuva <Hv glossed>iprattiks</Hv> ’minut
oli tapana syödä’ (yks. 1/3) ja <Hv>iprattiksi</Hv> (mon. 1/3). Passiivin koko järjestelmään
palataan <LessonLink n={44}>oppitunnilla 44</LessonLink>.

## Kertomus kirjeeseen

Näin aikamuodot jakavat työn kertomuksessa:

- **imperfekti**: tausta, mikä oli käynnissä (<Hv glossed>ȳdrēlen</Hv> ’olin puhumassa’)
- **perfekti**: tapahtumat peräkkäin (<Hv glossed>mastas</Hv> ’hän tuli’)
- **pluskvamperfekti**: mikä oli tapahtunut jo aiemmin (<Hv glossed>ipratten</Hv> ’olin syönyt’)
- **mennyt toistuva**: mikä oli tapana (<Hv glossed>pikīptia</Hv> ’sinulla oli tapana lukea’)

## Harjoituslauseita

<Practice hv="Ȳdrēlen, se ziry mastas." fi="Olin puhumassa, ja (silloin) hän tuli." />

<Practice hv="Sīr ipratten." fi="Olin jo syönyt." />

<Practice hv="Tembyri pikīptia." fi="Sinulla oli tapana lukea kirjoja." />

<Practice hv="Ēlī Valyriot istan." fi="Ensin menin Valyriaan." />

## Kirjeitä toisillemme

Kirjeet-sivulla olette kirjoittaneet toisillenne joka viikko kurssin alusta asti. Tämä osa kokoaa kirjeen kokonaiseksi. Malliksi luetaan ainoa kokonainen valyriankielinen kirje, joka on nähty ruudulla, ja sen jälkeen kootaan sanakirjasta kirjeen osat: puhuttelu, kuulumiset, rakkaudentunnustukset, toivotukset, lopetus ja päiväys.

Yksi periaate pätee koko loppukurssin ajan: **kirjeessä saa käyttää vain sellaista, mikä on joko sanakirjassa valmiina ilmauksena tai rakennettu tarkistetuista muodoista tuttujen mallien mukaan.** Kun kirjoitatte jotakin uutta, sovelluksen kääntäjä ja muotojen tarkistus auttavat. Jos kääntäjä on epävarma tai merkitsette käännöksen vääräksi, lause siirtyy kääntäjän listalle ”Odottaa tarkistussessiota”, ja se käännetään seuraavassa tarkistussessiossa. Epävarmuus ei ole virhe vaan hyvää harjoitusta.

## Talisan kirje

Game of Thronesin kolmannen kauden seitsemännessä jaksossa Talisa kirjoittaa äidilleen Volantisiin. Kirje on korkeavalyriaa, ja se on käännetty wikiin lause lauseelta. Siinä on kaikki, mitä hyvä kirje tarvitsee.

Ensin koko kirje sellaisena kuin se näkyy ruudulla:

<Line id="got-s3e07-letter" />

Käydään se sitten läpi lause lauseelta.

**Puhuttelu ja ensimmäinen lause.**

<Example id="ex-8ed810d2f0a2" />

<Interlinear hv="Muñus jorrāeliarzus:" gloss="äiti-VOC rakastettu-LUN.VOC" fi="Rakkain äiti:" />

Puhuttelu on vokatiivissa, ja määrite on **jälkiasemassa** (<LessonLink n={47}>oppitunti 47</LessonLink>). <Hv glossed>Jorrāeliarza</Hv> on verbin <Hv glossed>jorrāelagon</Hv> ’rakastaa’ partisiippi, siis ’rakastettu’.

Ensimmäinen lause, <Hv>Olvie hen embraro tolmiot nykēlot avy ivestragon issa</Hv>, on sanatarkasti *paljon merten tuolta puolen on minulle kerrottavaa sinulle*. Rakenne *datiivi + infinitiivi + <Hv l="sagon">issa</Hv>* vastaa suomen rakennetta *minulla on kerrottavaa*.

**Uutinen ja tunne.**

<Example id="ex-5af89bfd82cf" />

Tämän lauseen osaat purkaa kokonaan <LessonLink n={46}>oppitunnin 46</LessonLink> jälkeen: <Hv glossed>Nykēlo syt ūndon daor luo valzȳro</Hv>, *aviomiehen, jota en itselleni nähnyt*, ja sitten <Hv glossed>ñōghossi ōressiks</Hv>, *minua pidetään käsivarsilla*. <Hv l="lua">Luo</Hv> on genetiivissä, koska aviomies on päälauseessa käsivarsien omistaja.

<Example id="ex-13537ed19fcd" />

Tässä on epäsuora esitys ilman *että*-sanaa (<LessonLink n={39}>oppitunti 39</LessonLink>). Jälkimmäinen puolisko, *ja sydämeni mukaan se on totta*, on kauniisti vähäeleinen.

**Suuri uutinen.**

<Example id="ex-bb25187388bd" />

Tässä yhdessä virkkeessä on <Hv glossed>kesrio syt</Hv> ’sillä’ (ks. <LessonLink n={46}>oppitunti 46</LessonLink>), relatiivilause <Hv glossed>zijo syt pyghas lue prūmie</Hv> ’sydän, joka lyö hänelle’ (ks. <LessonLink n={46}>oppitunti 46</LessonLink>) ja verbi <Hv glossed>gōvilagon</Hv> ’olla jonkin alla’. <Hv glossed>Lanta iksan</Hv> ’olen kaksi’ kertoo raskaudesta yhtä kiertelemättä kuin englanti.

**Lopetus: toivo tulevasta.**

<Example id="ex-c9b6b47ca314" />

<Hv glossed>Aderī, mōrī</Hv> tarkoittaa ’pian, lopussa’. Viimeinen lause, <Hv glossed>Hēnkirī īlvi biarvī manaerili</Hv>, *juhlimme yhdessä*, on wikin juhlasanastossa sellaisenaan. Sanatarkasti se on *nostamme onnemme yhdessä*.

Kirjeen rakenne on siis tämä: puhuttelu vokatiivissa, kerrottava asia, oma tunne, uutinen ja lopuksi yhteinen tulevaisuus. Se on hyvä malli teidänkin kirjeillenne.

## Puhuttelu

Kirjeen alkuun tulee puhuttelu vokatiivissa, ja omistusadjektiivi on usein jäljessä, kuten sarjassa: <Hv glossed>dārilaros ñuhys</Hv> ’prinssini’, <Hv glossed>dārys ñuhys</Hv> ’kuninkaani’. Sanakirjassa on kolme hellittelysanaa, jotka tarkoittavat ’rakas, kulta’:

- <Hv>raqītsos</Hv>, verbistä <Hv glossed>raqagon</Hv> ’pitää, rakastaa’ + deminutiivi <Hv>-ītsos</Hv> (johtimista lisää <LessonLink n={48}>oppitunnilla 48</LessonLink>), siis ’pikku rakas’. Sana on aurinkosukuinen, ja sen vokatiivi on sama kuin nominatiivi.
- <Hv glossed>jorrāeliarzy</Hv> ’rakastettu, hellittelynimi’. Sana on kuusukuinen, ja sen vokatiivi on <Hv l="jorrāeliarzy">jorrāeliarzys</Hv>.
- <Hv glossed>raqiarzy</Hv> ’rakastettu’.

Omat nimenne ovat lainasanoja, ja niiden vokatiivi riippuu siitä, mihin <Term id="deklinaatio">taivutusluokkaan</Term> nimi sopii (Duolingon osio *Tunnettu maailma*, <LessonLink n={29}>oppitunti 29</LessonLink>). Sarjan malleja ovat <Hv>Rhaenyrus</Hv> ja <Hv>Daemos</Hv>. Teidän omat nimenne, niiden taivutuksen ja vokatiivit löydätte sivulta <NamesLink>Meidän nimet</NamesLink>.

## Kuulumiset

<Example id="ex-8b624009f31c" />

<Example id="ex-f3f40cf567d3" />

Wikin tervehdyssivulla kysymys *mitä kuuluu?* on <Hv glossed>Skorkydoso glaesā?</Hv>, sanatarkasti *miten elät?* Jos kirjeessä on huonoja uutisia, sanakirjasta löytyy lohdutukseksi tämä:

<Example id="ex-33b16c683c61" />

Kiitoksen voi esittää muodollisesti verbillä <Hv glossed>rytsuragon</Hv> ’tervehtiä, kiittää’ (sanakirjan mukaan *kirimvose* + akkusatiivi), kuten Fennesz kuningattarelle:

<Example id="ex-4cfb0b7129c5" />

Arkisemmin:

<Example id="ex-ee655aa956a2" />

## Rakkaudesta

Wikin rakkaussivulla on valmiita lauseita, joita voi käyttää sellaisenaan: <Hv glossed>Aōhon iksan se ñuhon iksā</Hv> ’olen sinun ja sinä olet minun’ ja <Hv glossed>Ñuho prūmiā iksā</Hv> ’olet sydämessäni’. Lisäksi:

<Example id="ex-c53f25e7a310" />

Kaunein kirjeen lopetus on sanakirjan esimerkkilause, jossa on sidesana <Hv glossed>iā</Hv> ’kunnes’ (tarkemmin <LessonLink n={46}>oppitunnilla 46</LessonLink>) ja subjunktiivi:

<Example id="ex-dc8bd0596993" />

## Toivotukset

<Example id="ex-fa2a87cec2d2" />

Uudenvuodentoivotus sopii tammikuun kirjeeseen. Syntymäpäivää varten sanakirjassa on kaksi vaihtoehtoa. Juhlasanaston *ad hoc* -lause <Hv glossed>Tubī hae kesīr sittāks sesīr kirine iksan</Hv> tarkoittaa ’synnyit tällaisena päivänä, ja siksi olen iloinen’. Toinen on lyhyempi:

<Example id="ex-6ba5d2eba7fc" />

<Example id="ex-45fe8b619c5e" />

Lahjan mukana:

<Example id="ex-5fab68e6d60d" />

## Lopetus

<Example id="ex-584ff507e062" />

<Hv glossed>Geros ilas</Hv> tarkoittaa ’näkemiin’. Sanakirjassa on myös lyhyempi muoto <Hv glossed>Geros!</Hv>, joka on sanatarkasti ’oi polku!’ (sanan <Hv>geron</Hv> vokatiivi), sekä hyvästely <Hv glossed>Biarvī!</Hv> ’onnea!’. Kirjeen lopussa voi myös vain kirjoittaa nimensä.

## Päiväys ja otsikko

Sarjassa viestin vastaanottaja merkitään yksinkertaisesti: *jollekulle* (<Hv>syt</Hv> + genetiivi).

<Example id="ex-8137c0dc87dd" />

Peterson käänsi kerran mainoksen, jossa oli päivämäärä:

<Example id="ex-7cd1b4b8215d" />

<Hv glossed>Masso jēdo tōmeliē ampā tubī</Hv> on ’lepakon kauden viidentenätoista päivänä’. Järjestysluku <Hv glossed>tōmelie ampā</Hv> ’15.’ (ks. <LessonLink n={48}>oppitunti 48</LessonLink>) on lokatiivissa samoin kuin <Hv l="tubis">tubī</Hv>. *Lepakon kausi* on tässä lokakuu. Wikissä ei ole muita kuukausien nimiä. Tämän oppitunnin sanalistassa ovat kurssin omat kuukausien nimet, jotka on tehty samalla mallilla, esimerkiksi <Hv glossed>Nīro Jēda</Hv> ’tammikuu’, sanatarkasti ’tammen kausi’. Ne ovat meidän sanojamme, eivät Petersonin. Päivän järjestysluvun voi muodostaa samalla tavalla:

<Practice hv="Saeliē ampā tubī." fi="Kolmantenatoista päivänä." />

## Kokoa oma kirje

<Practice hv="Raqītsos ñuhys," fi="Rakkaani," />

<Practice hv="Jorrāeliarzys ñuhus," fi="Rakkaani," />

<Practice hv="Olvie nykēlot avy ivestragon issa." fi="Minulla on paljon kerrottavaa sinulle." />

<Practice hv="Aderī aōt māzīnna." fi="Tulen pian luoksesi." />

Ja sitten kirjoittamaan: puhuttelu, yksi uutinen, yksi tunne, yksi toivotus ja lopetus. Viisi lausetta riittää ensimmäiseen kirjeeseen.

## Sanat

<Vocab />

<Check />
